import { mapErrorMessage } from "./errorMessage";
import plansInfo from "../data/plans-info.json";
import { getInsuranceLocalInfo } from "./getInsuranceLocalInfo";

function encodeStr(str) {
  return btoa(str);
}

function getPlanInfo(insuranceType) {
  return plansInfo[insuranceType];
}

function capitalize(s) {
  if (typeof s !== "string") return "";
  return s
    .trim()
    .toLowerCase()
    .replace(/\w\S*/g, (w) => w.replace(/^\w/, (c) => c.toUpperCase()));
}

export {
  mapErrorMessage,
  encodeStr,
  getInsuranceLocalInfo,
  getPlanInfo,
  capitalize,
};
